import gql from 'graphql-tag';

export const MODIFY_PURCHASE_ORDER_ITEM = gql`
	mutation modifyPurchaseOrderItemMutation ($input: ModifyPurchaseOrderItemInput!) {
		modifyPurchaseOrderItem (input: $input) {
			purchaseorderitem {
				id
				quantity
				originalQuantity
				notDeliveredAt
				deliveryOutcome
				warehouseProduct {
					id
					quantity
					product {
						id
						name
						imageUrl
						caseSize
						shipperSize
						palletSize
						forceQuantityInUnits
					}
				}
				stockDeliveryItem {
					id
					deliveredAt
					receivedAt
					stockDelivery {
						id
						identifier
					}
				}
			}
		}
	}
`;
